import { httpRequest } from '../request'

enum Apis {
  getSendVmsCodeAPI = 'send_vms_code',
}
interface CommonResponse<T = any> {
  status: number
  msg: string
  data: T
}

/**
 * @description 发送语音验证码
 * @link https://api.thinkerx.com/web/#/159/15486
 */
export const getSendVmsCodeAPI = (params: {
  phone: string
  platform: string
  area_code: string
  type: string
}) => {
  return httpRequest.post<CommonResponse>(Apis.getSendVmsCodeAPI, params)
}
